// @ts-strict-ignore
import { AppStoreType } from '../../types';
import * as React from 'react';
import Text from 'antd/lib/typography/Text';
import { getIsGooglePlayStore } from '../../helpers';
import {
    convertUserFraction,
    convertAndroidStagedRolloutPercentage,
    displayStringForRolloutPercentage,
} from '../../helpers/displayHelpers';

interface PhasedReleasePercentProps {
    appStoreType: AppStoreType;
    isRolloutComplete: boolean;
    userFraction?: number;
    percentColor: string;
}

const PhasedReleasePercent: React.FC<PhasedReleasePercentProps> = (props: PhasedReleasePercentProps) => {
    const isGooglePlayStore = getIsGooglePlayStore(props.appStoreType);

    const rolloutPercentage =
        isGooglePlayStore ?
            (
                props.isRolloutComplete // when android release is complete show 100 cuz userFraction returns 0
            ) ?
                100
            :   convertAndroidStagedRolloutPercentage(props.userFraction)
        :   convertUserFraction(props.userFraction);

    const displayRolloutPercentage = displayStringForRolloutPercentage(rolloutPercentage);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', marginTop: 12 }}>
            <Text
                style={{
                    fontSize: 44,
                    color: props.percentColor,
                    fontWeight: 600,
                    lineHeight: '72px',
                    marginLeft: -10,
                }}
            >
                {displayRolloutPercentage}
            </Text>
            <Text style={{ textTransform: 'uppercase', letterSpacing: '0.1em' }} type="secondary">
                of users
            </Text>
        </div>
    );
};

export default PhasedReleasePercent;
